import { useEffect, useState } from "react";

import { Progress, WorldCupBar, GameBody } from "../components";

import { useNavigate } from "react-router-dom";

const gameData = [
  { id: 0, name: "EliJ", image: "/worldcup/imgs/woman/EliJ.webp" },
  { id: 1, name: "Sprring", image: "/worldcup/imgs/woman/Sprring.webp" },
  { id: 2, name: "데이지빗", image: "/worldcup/imgs/woman/데이지빗.webp" },
  { id: 3, name: "둥둥이에용", image: "/worldcup/imgs/woman/둥둥이에용.webp" },
  { id: 4, name: "르네르", image: "/worldcup/imgs/woman/르네르.webp" },
  { id: 5, name: "리트리버양", image: "/worldcup/imgs/woman/리트리버양.webp" },
  { id: 6, name: "마몽드", image: "/worldcup/imgs/woman/마몽드.webp" },
  {
    id: 7,
    name: "미니언즈123",
    image: "/worldcup/imgs/woman/미니언즈123.webp",
  },
  { id: 8, name: "민팅", image: "/worldcup/imgs/woman/민팅.webp" },
  { id: 9, name: "뿜뿜뿜", image: "/worldcup/imgs/woman/뿜뿜뿜.webp" },
  {
    id: 10,
    name: "사과꽃",
    image: "/worldcup/imgs/woman/사과꽃.webp",
  },
  { id: 11, name: "파란하늘꿈", image: "/worldcup/imgs/woman/파란하늘꿈.webp" },
  {
    id: 12,
    name: "루루까꿍",
    image: "/worldcup/imgs/woman/루루까꿍.webp",
  },
  { id: 13, name: "산들바람", image: "/worldcup/imgs/woman/산들바람.webp" },
  { id: 14, name: "얼린뽕따", image: "/worldcup/imgs/woman/얼린뽕따.webp" },
  { id: 15, name: "여르미", image: "/worldcup/imgs/woman/여르미.webp" },
];

export default function Man() {
  const TOTAL_ROUND = 15;
  const navigator = useNavigate();
  const [result, setResult] = useState(false);
  const [gameProgress, setGameProgress] = useState({
    game16: [],
    game8: [],
    game4: [],
    game2: [],
    last: [],
  });
  const [completedRound, setCompletedRound] = useState(0);
  const [progressRound, setProgressRound] = useState(null);
  const [selectedCards, setSelectedCards] = useState([]);
  const [remainingCards, setRemainingCards] = useState(gameData);

  const initializeGame = () => {
    const shuffled = remainingCards.sort(() => 0.5 - Math.random());
    const selected = shuffled.slice(0, 2);
    setGameProgress((prev) => ({ ...prev, game16: shuffled }));
    setSelectedCards(selected);
  };
  const startGame = (list, result) => {
    const remaining = remainingCards.slice(2);

    if (gameProgress.game8.length < 8) {
      setGameProgress((prev) => ({
        ...prev,
        game8: [...prev.game8, list],
      }));
    } else if (
      gameProgress.game4.length < 4 &&
      gameProgress.game8.length === 8
    ) {
      setGameProgress((prev) => ({
        ...prev,
        game4: [...prev.game4, list],
      }));
    } else if (
      gameProgress.game2.length < 2 &&
      gameProgress.game4.length === 4
    ) {
      setGameProgress((prev) => ({
        ...prev,
        game2: [...prev.game2, list],
      }));
    } else if (
      gameProgress.game2.length === 2 &&
      gameProgress.last.length === 0
    ) {
      setGameProgress((prev) => ({
        ...prev,
        last: [list],
      }));
    }

    setRemainingCards(remaining);
    setCompletedRound((prev) => {
      return prev + 1;
    });
    if (result) {
      setResult(true);
    }
  };

  useEffect(() => {
    initializeGame();
    gameData.forEach(({ image }) => {
      const img = new Image();
      img.src = image;
    });
  }, []);
  useEffect(() => {
    if (gameProgress.game8.length === 8 && gameProgress.game4.length === 0) {
      setRemainingCards(gameProgress.game8);
      setCompletedRound(0);
    } else if (
      gameProgress.game4.length === 4 &&
      gameProgress.game2.length === 0
    ) {
      setRemainingCards(gameProgress.game4);
      setCompletedRound(0);
    } else if (
      gameProgress.game2.length === 2 &&
      gameProgress.last.length === 0
    ) {
      setRemainingCards(gameProgress.game2);
      setCompletedRound(0);
    }
    setSelectedCards(remainingCards.slice(0, 2));
    const progressRound = (completedRound / TOTAL_ROUND) * 100;
    setProgressRound(progressRound.toFixed(0));

    if (result) {
      const url = new URLSearchParams();
      url.append("image", gameProgress.last[0].image);
      url.append("name", gameProgress.last[0].name);
      url.append("id", gameProgress.last[0].id);
      const query = url.toString();
      navigator(`/result?${query}`);
    }
  }, [remainingCards]);
  const round = () => {
    if (gameProgress.game8.length < 8) return "1라운드";
    if (gameProgress.game4.length < 4) return "2라운드";
    if (gameProgress.game2.length < 2) return "3라운드";
    if (gameProgress.game2.length === 2) return "결승";
  };
  return (
    <>
      <Progress
        round={round}
        progressRound={progressRound}
        gameProgress={gameProgress}
        completedRound={completedRound}
      />
      <div
        className="container gameContainer"
        style={{
          borderRadius: "20px",
          position: "relative",
          paddingTop: 0,
          background: "#fff",
        }}
      >
        <GameBody
          gameData={selectedCards}
          startGame={startGame}
          result={gameProgress.game2.length === 2 && true}
        />
      </div>
    </>
  );
}
